import { Routes, Route } from "react-router";
import ScrollToTop from "./components/ScrollToTop.tsx";
import PageFrame from "./components/layout/PageFrame.tsx";
import Home from "./routes/Home.tsx";
import Collection from "./routes/Collection.tsx";
import Create from "./routes/Create.tsx";
import Creation from "./routes/Creation.tsx";
import CreationScroll from "./routes/CreationScroll.tsx";
import ProductDetail from "./routes/ProductDetail.tsx";
import ProductThankYou from "./routes/ProductThankYou.tsx";
import Craft from "./routes/Craft.tsx";
import Contact from "./routes/Contact.tsx";
import Admin from "./routes/Admin.tsx";
import Terms from "./routes/legal/Terms.tsx";
import Privacy from "./routes/legal/Privacy.tsx";
import Refunds from "./routes/legal/Refunds.tsx";

export default function App() {
  return (
    <PageFrame>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/collection" element={<Collection />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/thank-you" element={<ProductThankYou />} />
        <Route
          path="/product/:slug/thank-you"
          element={<ProductThankYou />}
        />
        <Route path="/create" element={<Create />} />
        <Route path="/creation/:slug" element={<Creation />} />
        <Route path="/creation/:slug/scroll" element={<CreationScroll />} />
        <Route path="/craft" element={<Craft />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refunds" element={<Refunds />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </PageFrame>
  );
}
